export default {
  authenticated: () => import("/app/apps/nuxt-front/layouts/authenticated.vue"),
  default: () => import("/app/apps/nuxt-front/layouts/default.vue"),
  error: () => import("/app/apps/nuxt-front/layouts/error.vue"),
  unauthenticated: () => import("/app/apps/nuxt-front/layouts/unauthenticated.vue")
}